import { EDITOR_TOOLS } from '@editor/config/constants'
import { CursorState } from '@editor/config/constants/cursor'
import { EditorTool } from '@editor/interfaces/editor'

import useMainCanvas from './hooks/useMainCanvas'

const CameraFocus: EditorTool = {
  key: EDITOR_TOOLS.FOCUS,
  cursor: CursorState.CROSSHAIR,
  authCheck: () => true,
  hooks: {
    useMainCanvas,
  },
}

export default CameraFocus
